// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_CBE","cls2":"Configuration-cls2_nBl Configuration-cls1_CBE"};